import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { fundingFont } from '../../theme/fundingTypography'

/** Matches the `lg` breakpoint, for when the chat dock — not the window —
 *  is what made the page narrow. */
const NARROW_CONTAINER = '@container labra-chat-main (max-width: 1200px)'

export const useStyles = makeStyles()(theme => ({
  page: {
    boxSizing: 'border-box',
    width: '100%',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    minWidth: 0,
  },
  /** Same red ribbon pattern as TemplateDetail archive banner. */
  setupBanner: {
    boxSizing: 'border-box',
    flexShrink: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 24px',
    margin: 0,
    borderRadius: 0,
    backgroundColor: C.archiveBannerBg,
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.strongText,
  },
  setupBannerLink: {
    color: C.linkBlue,
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  root: {
    boxSizing: 'border-box',
    width: '100%',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    gap: 24,
    alignItems: 'stretch',
    padding: 24,
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      overflowY: 'auto',
    },
    [NARROW_CONTAINER]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      overflowY: 'auto',
    },
  },
  leftColumn: {
    flex: '1 1 0',
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    '& > :not(:last-child)': {
      flexShrink: 0,
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      flex: 'none',
    },
    [NARROW_CONTAINER]: {
      width: '100%',
      flex: 'none',
    },
  },
  rightColumn: {
    width: 444,
    flexShrink: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    // Cap the panel to the row (table) height and split it across the boxes so
    // the page itself never scrolls — each box scrolls internally instead.
    overflow: 'hidden',
    '& > *': {
      flex: '1 1 0',
      minHeight: 0,
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      overflow: 'visible',
      '& > *': {
        flex: 'none',
      },
    },
    [NARROW_CONTAINER]: {
      width: '100%',
      overflow: 'visible',
      '& > *': {
        flex: 'none',
      },
    },
  },
}))
